import { MapPin, Users } from "lucide-react";
import { useEffect, useState } from "react";

import { anunciosMetaApi, km } from "../api";
import Cartao from "./Cartao";
import MapaRaio from "./MapaRaio";

const RAIO_MAX_BARRA = 20;
const milhar = (n) => (n >= 1000 ? `${(n / 1000).toLocaleString("pt-BR", { maximumFractionDigits: 1 })} mil` : String(n));

/** Passo 3: o raio em volta da loja, com a estimativa de pessoas que a Meta dá para ele. */
export default function SecaoOnde({ a }) {
  const { latitude, longitude } = a.dados.local || {};
  const raio = a.form.raioKm;
  const [alcance, setAlcance] = useState(null);

  // Espera a loja parar de mexer na barra antes de perguntar à Meta.
  useEffect(() => {
    if (latitude == null) return undefined;
    let vivo = true;
    const timer = setTimeout(() => {
      anunciosMetaApi.alcance({ raio_km: raio }).then((r) => vivo && setAlcance(r)).catch(() => vivo && setAlcance(null));
    }, 600);
    return () => { vivo = false; clearTimeout(timer); };
  }, [raio, latitude]);

  return (
    <Cartao numero={3} titulo="Onde aparece" icone={MapPin} e2e="impulsionar-onde"
      descricao="O anúncio aparece para quem está dentro do círculo em volta da loja. A Meta escolhe, ali dentro, quem tem mais chance de pedir.">
      {latitude == null ? (
        <p className="text-sm text-amber-600 rounded-lg bg-amber-500/10 px-3 py-3">A loja ainda não está marcada no mapa. Volte para Anúncios Meta e marque o ponto da loja.</p>
      ) : (
        <div className="space-y-3">
          <MapaRaio latitude={latitude} longitude={longitude} raioKm={raio} />
          <label className="flex items-center gap-3 text-sm">
            <span className="text-muted-foreground shrink-0">Raio</span>
            <input type="range" min={1} max={Math.max(RAIO_MAX_BARRA, raio)} step={0.5} value={raio}
              onChange={(e) => a.definir("raioKm", Number(e.target.value))} className="flex-1 accent-primary" data-e2e="impulsionar-raio" />
            <span className="font-semibold tabular-nums w-14 text-right" data-e2e="impulsionar-raio-valor">{km(raio)}</span>
          </label>
          <p className="flex items-center gap-1.5 text-sm" data-e2e="impulsionar-alcance">
            <Users className="w-4 h-4 text-muted-foreground shrink-0" />
            {alcance?.de != null
              ? <span>A Meta estima entre <b>{milhar(alcance.de)}</b> e <b>{milhar(alcance.ate)}</b> pessoas neste raio.</span>
              : <span className="text-muted-foreground">A estimativa de pessoas aparece aqui quando a Meta responder.</span>}
          </p>
          <p className="text-[11px] text-muted-foreground">Raio maior alcança mais gente, mas espalha o investimento. Comece pelo raio em que a loja entrega.</p>
        </div>
      )}
    </Cartao>
  );
}
